import { Link, useLocation } from "react-router-dom";
import { SERVICES, STATIC_PATHS, langFromPath, servicePath } from "@/lib/services";
import { ui } from "@/lib/siteText";
import { SITE_CONFIG } from "@/lib/constants";
import { ContactDetails } from "@/components/site/SiteBlocks";

const Footer = () => {
  const { pathname } = useLocation();
  const lang = langFromPath(pathname);
  const t = ui(lang);
  return (
    <footer className="border-t border-border bg-card/60">
      <div className="container grid gap-10 py-14 md:grid-cols-3">
        <div>
          <p className="font-display text-xl font-bold">CYSCOM</p>
          <p className="mt-3 max-w-xs text-sm text-muted-foreground">{t.heroText}</p>
          <a href="https://cyscom.nl" className="mt-4 inline-block text-sm text-primary hover:underline">cyscom.nl</a>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-wider text-muted-foreground">{t.services}</p>
          <ul className="mt-4 space-y-2 text-sm">
            {SERVICES.map((s) => (
              <li key={s.key}><Link to={servicePath(s.key, lang)} className="hover:text-primary">{s.name[lang]}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <p className="mb-4 font-mono text-xs uppercase tracking-wider text-muted-foreground">{t.contact}</p>
          <ContactDetails lang={lang} />
        </div>
      </div>
      <div className="border-t border-border">
        <div className="container flex flex-col gap-3 py-6 text-xs text-muted-foreground sm:flex-row sm:justify-between">
          <span>© {new Date().getFullYear()} {SITE_CONFIG.companyName}. {t.rights}</span>
          <span className="flex gap-4">
            <Link to={STATIC_PATHS.privacy[lang]} className="hover:text-primary">{t.privacy}</Link>
            <Link to={STATIC_PATHS.terms[lang]} className="hover:text-primary">{t.terms}</Link>
            <Link to={STATIC_PATHS.cookies[lang]} className="hover:text-primary">{t.cookies}</Link>
            <Link to="/sitemap" className="hover:text-primary">Sitemap</Link>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
